// We use the same environment for development and staging
// But we still need a switch to only show dev features locally
// Note: Create React App automatically loads .env files - no need to import dotenv
export const isDevelopment = () =>  true // process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "development";
export const isProductionTest = () => process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "production-test";
export const isProduction = () => process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === "production" || isProductionTest();
export const isStaging = () => !isDevelopment() && !isProduction() && !isProductionTest();
export const API_URL = process.env.REACT_APP_API_URL || "";
export const WSS_URL = process.env.REACT_APP_WSS_URL || "";
export const SOCKET_IO_PATH = process.env.REACT_APP_SOCKET_IO_PATH || "/socket.io";
export const INVITE_ACCESS_ENABLED =
  process.env.REACT_APP_INVITE_ACCESS_ENABLED === "true";
